import { AbstractComponent } from "appworks/components/abstract-component";
import { Point } from "appworks/utils/geom/point";
import { TGRLinesComponent } from "components/tgr-lines-component";
import { LinesComponentFactory } from "slotworks/components/factories/lines-component-factory";
import { LinesComponentConfig } from "slotworks/components/lines/lines-component";

export class TGRLinesComponentFactory extends LinesComponentFactory {

    constructor(protected lineDefinitions: Point[][], protected config?: LinesComponentConfig) {
        super(lineDefinitions, config);
    }

    public build(): AbstractComponent {
        return new TGRLinesComponent(this.lineDefinitions, this.config);
    }
}
